import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonDataService } from '../../services/common-data.service';
import { first } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var $:any;
declare var iziToast:any;

import { environment } from '../../../environments/environment';
import { IfStmt } from '@angular/compiler';

@Component({
  selector: 'app-account-login-page',
  templateUrl: './account-login-page.component.html',
  styleUrls: ['./account-login-page.component.css']
})
export class AccountLoginPageComponent implements OnInit {
  
  pageName = "Login / Register Account";
  returnUrl: string;

  fnWarning = false;
  lnWarning = false;
  emailWarning = false;
  phoneWarning = false;
  passWarning = false;
  passconfirmWarning = false;
  
  constructor(private _data: CommonDataService, private authService: AuthService, private router: Router, private httpClient: HttpClient, private route: ActivatedRoute) { }

  ngOnInit() {
  	$('#initialise-page').trigger('click');
      this.authService.logout();
      this.authService.authDetailsChanged.next([]);
      
      $('#loader').hide();
  }

  login() {

    $('#buttonText').text('Please Wait...');
    $('#loader').show();

  	let password = $('#password').val();
  	let username = $('#email').val();
  
  	this.httpClient.post(environment.apiUrl+"/api-login",
        {
            "auth_password": password,
            "auth_username": username
        })
        .subscribe(
            data => {
                console.log("POST Request is successful ", data);
            },
            error => {
                console.log("Error", error);

                let h = {
                    class: "iziToast-warning",
                    title:  "Login:",
                    message:  "failed to login!Try again",
                    animateInside: !1,
                    position: "topRight",
                    progressBar: !1,
                    icon: "icon-bell",
                    timeout: 3200,
                    transitionIn: "fadeInLeft",
                    transitionOut: "fadeOut",
                    transitionInMobile: "fadeIn",
                    transitionOutMobile: "fadeOut",
                  };
                  iziToast.show(h);

                $('#buttonText').text('Login ');
                $('#loader').hide();
            },

            () => {

                this.getUserProfile()
            }
        ); 
  }

  getUserProfile() {
    // this._data.getProfile() 
    // .pipe(first())
    // .subscribe(
    //   data => {
      this._data.getProfile().toPromise().then(data => {
        let userDetails =  data['cover']['model']['modelData']['formFieldsEntities'];
        this.authService.saveSessionDetails(userDetails['PersonalDetails'], 'PersonalDetails');
        
        let context = data['cover']['id'];
        let contextData = data['cover']['model']['modelData'];

        this.authService.saveSessionDetails(context, 'context');
        this.authService.saveSessionDetails(data['cover']['created'], 'created');
        this.authService.saveSessionDetails(contextData, 'contextData');
        this.authService.authDetailsChanged.next([]);

        //email verificiation checks
        if(data['cover']['model']['modelData']['systemManagedEntities'] != undefined) {

          if(data['cover']['model']['modelData']['systemManagedEntities']['registrationSettings'] != undefined) {

            if(data['cover']['model']['modelData']['systemManagedEntities']['registrationSettings']['emailConfirmed'] != undefined &&
            data['cover']['model']['modelData']['systemManagedEntities']['registrationSettings']['emailConfirmed'] == true && 
            data['cover']['model']['modelData']['systemManagedEntities']['registrationSettings']['status'] == 'ACTIVE'
            ) {
                  sessionStorage.setItem('yheyhhshshveri', 'atyyctjsjsiggv===')
            }
          }
        }
        
        this.checkIfUserIsSeller(context)

        $('#buttonText').text('Login ');
        $('#loader').hide();
        //continue where you left off
        //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        //console.log(this.returnUrl)
        //this.router.navigateByUrl(this.returnUrl);
        // this.router.navigate(['/account/profile']);
      },
      error => {
        console.log(error);

        let h = {
            class: "iziToast-warning",
            title:  "Profile:",
            message:  "failed to load! Contact Support",
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 3200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);

          this.checkIfUserIsSeller("0")


      });
  }

  checkIfUserIsSeller(context) {
    let queryData = new FormData();
    queryData.append('modelName', "SellerProfile");
    queryData.append('context_id', context);

    //lets get the model for this page
    this._data.getModelData(queryData).toPromise().then(data => {
    // .pipe(first())
    // .subscribe(
      // data => {
        
        if(data['covers'].length > 0) {
          sessionStorage.setItem('BNFGSHGFGG', 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045');
        }

        this.authService.authDetailsChanged.next([]);

        this.router.navigate(['/account/profile']);

      },
      error => {
        this.router.navigate(['/account/profile']);
        this.authService.authDetailsChanged.next([]);
      }
    );
  }

  register() {

  	let first_name = $('#reg-fn').val();
  	let last_name = $('#reg-ln').val();
  	let email = $('#reg-email').val();
  	let phone = $('#reg-phone').val();
  	let password = $('#reg-pass').val();
  	let confirm_password = $('#reg-pass-confirm').val();

  	if(this.validateFields()) {
      if(password == confirm_password ) {

        $('#buttonText2').text('Please Wait...');
        $('#loader').show();

        this.httpClient.post(environment.apiUrl+"/api-register-user",
          {
              "auth_password": password,
              "auth_username": email,
              "first_name": first_name,
              "last_name": last_name,
              "phone": phone,
              "source_id" : "6736FDPBVTGACFARVVVSFARTW6353GDAC",
              "email": email
  
          })
          .subscribe(
              data => {
                  console.log("POST Request is successful ", data);
              },
              error => {
                  console.log("Error", error);
  
                  $('#buttonText2').text('Register ');
                  $('#loader').hide();
  
                  iziToast.success({
                      title: 'Error!',
                      position: 'topRight',
                      icon: 'icon-circle-check',
                      message: 'Failed to login into your profile.'
                  });
              },
  
              () => {
                  //continue where you left off
                  $('#buttonText2').text('Register ');
                  $('#loader').hide();
  
                  $('#reg-fn').val('');
                  $('#reg-ln').val('');
                  $('#reg-email').val('');
                  $('#reg-phone').val('');
                  $('#reg-pass').val('');
  
                  iziToast.success({
                    title: 'Success!',
                    position: 'topRight',
                    icon: 'icon-circle-check',
                    message: 'Your account has been successfully registered, You can now login and create your profile.'
                });
              }
          ); 
  
      }
      
      else  
        this.passconfirmWarning = true;
    }
  
  }

  validateFields() {

    this.fnWarning = false;
    this.lnWarning = false;
    this.emailWarning = false;
    this.phoneWarning = false;
    this.passWarning = false;
    this.passconfirmWarning = false;

    let first_name = $('#reg-fn').val();
    let fnWarning = this._data.validName.test(first_name)
    if(!fnWarning) {
      alert('wrong name format')
      this.fnWarning = true;
    }
      
    let last_name = $('#reg-ln').val();
    let lnWarning = this._data.validLastName.test(last_name)
    if(!lnWarning)
      this.lnWarning = true;

    let email = $('#reg-email').val();
    let emailWarning = this._data.validEmail.test(email)
    if(!emailWarning) {
      alert('wrong emailWarning format')
      this.emailWarning = true;
    }
      

    let phone = $('#reg-phone').val();
    let phoneWarning = this._data.validSAPhone.test(phone)
    if(!phoneWarning)
      this.phoneWarning = true;

    let password = $('#reg-pass').val();
    let passWarning = this._data.validPassword.test(password)
    if(!passWarning)
      this.passWarning = true;

    
    if(this.lnWarning || this.emailWarning || this.phoneWarning || this.passWarning )
      return false;

    else
     return true;

  }

}
